jQuery( document ).ready(function($) {
    let form_right_column = jQuery( '.af-field-type-acfe-column:eq(1)' );
    let donate_submit_button = jQuery( '.af-submit-button' ).first().detach();

    form_right_column.append( donate_submit_button );
});